document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCountUp();
  initPosturas();
  initGaleria();
  initVariantes();
  initMarquesina();
});

function initReveal() {
  var els = document.querySelectorAll('.so-reveal');
  if (!els.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) {
    els.forEach(function (el) { el.classList.add('so-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry, i) {
      if (entry.isIntersecting) {
        var el = entry.target;
        var delay = el.dataset.soDelay || (i * 80);
        setTimeout(function () { el.classList.add('so-visible'); }, delay);
        observer.unobserve(el);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });

  // Red de seguridad: revela lo que ya está en pantalla aunque el observador
  // tarde (pasa, por ejemplo, si la página se abre en una pestaña de fondo).
  function revelarLoVisible() {
    var alto = window.innerHeight || document.documentElement.clientHeight;
    els.forEach(function (el) {
      if (el.classList.contains('so-visible')) return;
      var r = el.getBoundingClientRect();
      if (r.top < alto * 0.92 && r.bottom > 0) el.classList.add('so-visible');
    });
  }
  window.addEventListener('load', revelarLoVisible);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) revelarLoVisible();
  });
  setTimeout(revelarLoVisible, 1200);
}

function initCountUp() {
  var els = document.querySelectorAll('.so-count[data-target]');
  if (!els.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var target = parseFloat(el.dataset.target) || 0;
      var suffix = el.dataset.suffix || '';
      var duration = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var value = (target * eased);
        el.textContent = (target % 1 === 0 ? Math.round(value) : value.toFixed(1)) + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
      observer.unobserve(el);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { observer.observe(el); });
}

function initPosturas() {
  document.querySelectorAll('[data-so-posturas]').forEach(initPestanas);
}

function initPestanas(wrap) {
  var tabs = wrap.querySelectorAll('[data-so-tab]');
  var panels = wrap.querySelectorAll('[data-so-panel]');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var key = tab.getAttribute('data-so-tab');
      tabs.forEach(function (t) { t.classList.remove('is-active'); });
      panels.forEach(function (p) { p.classList.remove('is-active'); });
      tab.classList.add('is-active');
      var panel = wrap.querySelector('[data-so-panel="' + key + '"]');
      if (panel) panel.classList.add('is-active');
    });
  });
}

function initGaleria() {
  document.querySelectorAll('[data-so-galeria]').forEach(initUnaGaleria);
}

function initUnaGaleria(wrap) {
  var main = wrap.querySelector('[data-so-galeria-principal]');
  var thumbs = wrap.querySelectorAll('[data-so-galeria-thumb]');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var full = thumb.getAttribute('data-full');
      var alt = thumb.getAttribute('data-alt') || '';
      if (main && full) {
        main.src = full;
        main.alt = alt;
      }
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });
}

function initVariantes() {
  var raices = document.querySelectorAll('[data-so-producto-form]');
  raices.forEach(function (raiz) {
    var form = raiz.tagName === 'FORM' ? raiz : raiz.querySelector('form');
    if (!form) return;
    var dataEl = raiz.querySelector('[data-so-variantes-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var grupos = raiz.querySelectorAll('[data-so-opcion]');
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = raiz.querySelector('[data-so-precio]');
    var compareEl = raiz.querySelector('[data-so-precio-comparado]');
    var submitBtn = raiz.querySelector('[data-so-submit]');
    if (!idInput) return;

    function moneyFmt(cents) {
      var moneda = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      try {
        return (cents / 100).toLocaleString(document.documentElement.lang || 'es-ES', {
          style: 'currency',
          currency: moneda
        });
      } catch (e) {
        return (cents / 100).toFixed(2) + ' ' + moneda;
      }
    }

    function valorDeGrupo(grupo) {
      if (grupo.tagName === 'SELECT') return grupo.value;
      var marcado = grupo.querySelector('input[type="radio"]:checked');
      return marcado ? marcado.value : null;
    }

    function seleccionActual() {
      var vals = [];
      grupos.forEach(function (g) { vals.push(valorDeGrupo(g)); });
      return vals;
    }

    function buscarVariante() {
      if (!grupos.length) return variants[0];
      var sel = seleccionActual();
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === sel[i]; });
      });
    }

    function textoBoton(clave, respaldo) {
      if (!submitBtn) return respaldo;
      return submitBtn.getAttribute('data-texto-' + clave) || respaldo;
    }

    function actualizar() {
      var variante = buscarVariante();
      if (!variante) {
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = textoBoton('no-disponible', 'No disponible');
        }
        return;
      }
      idInput.value = variante.id;
      if (priceEl) priceEl.textContent = moneyFmt(variante.price);
      if (compareEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          compareEl.textContent = moneyFmt(variante.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (submitBtn) {
        if (variante.available) {
          submitBtn.disabled = false;
          submitBtn.textContent = textoBoton('disponible', 'Añadir al carrito');
        } else {
          submitBtn.disabled = true;
          submitBtn.textContent = textoBoton('agotado', 'Agotado');
        }
      }
    }

    grupos.forEach(function (g) { g.addEventListener('change', actualizar); });
    actualizar();
  });
}

function initMarquesina() {
  document.querySelectorAll('[data-so-marquesina]').forEach(function (el) {
    var track = el.querySelector('[data-so-marquesina-track]');
    if (!track || track.dataset.soCloned) return;
    track.dataset.soCloned = 'true';
    track.innerHTML += track.innerHTML;
  });
}
